import React from 'react';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import ForgotPasswordForm from '../components/ForgotPasswordForm/ForgotPasswordForm';

function ForgotPassword() {
  return (
    <AuthCard>
      <AuthFormHeader />
      <ForgotPasswordForm />
    </AuthCard>
  );
}

export default ForgotPassword;
